import i18next from "src/i18n/config";

type Option = {
    label: string;
    value: API.Member["role"];
};

export const rolesOptions: Option[] = [
    { label: i18next.t("common:role.owner"), value: "Owner" },
    { label: i18next.t("common:role.manager"), value: "Manager" },
    { label: i18next.t("common:role.user"), value: "User" },
];

export const getAssignableRoleOptions = (canAssignOwner: boolean): Option[] =>
    canAssignOwner ? rolesOptions : rolesOptions.filter((option) => option.value !== "Owner");
